__turbopack_context__.v({
  "shell": "upliftWidget-module-scss-module__ujTg8q__shell",
  "spamNotice": "upliftWidget-module-scss-module__ujTg8q__spamNotice",
  "widget": "upliftWidget-module-scss-module__ujTg8q__widget",
  "widgetTall": "upliftWidget-module-scss-module__ujTg8q__widgetTall",
});
